// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d8b0ab9f","703":"b505d939","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};